<template>
    <div class="bandeau-container">
        <BorderedIconButton
            v-if="!first && !isEditing"
            :onClick="back"
            class="back-button"
            :imgUrl="imgUrl"
            :title="$t('app.bottom.navigation.button.back')"
        />
        <ButtonWhite
            v-if="cancel && !((confirm && cancel) || next)"
            name="annuler"
            class="button-cancel"
            :class="smallMarginRight && 'smallMarginLeft'"
            :onClick="cancel"
            :text="cancelText || $t('app.bottom.navigation.button.cancel')"
        />
        <div
            v-if="(confirm && cancel) || next"
            class="button-container"
            :class="smallMarginRight && 'smallMarginRight'"
        >
            <ButtonWhite name="annuler" :onClick="cancel" :text="$t('app.bottom.navigation.button.cancel')" />
            <ButtonBlue
                class="button-confirm"
                v-if="last && !noValidation"
                :disabled="confirmButtonDisabled"
                name="confirm"
                :onClick="confirm"
                :text="$t('app.bottom.navigation.button.confirm')"
            />
            <ButtonBlue
                class="button-confirm"
                v-if="!last"
                :disabled="confirmButtonDisabled"
                name="next"
                :onClick="next"
                :text="$t('app.bottom.navigation.button.next')"
            />
            <ReglePastille v-if="!last && regleCle" :cle="regleCle" />
        </div>
        <div v-else-if="confirm && !cancel" class="button-container" :class="smallMarginRight && 'smallMarginRight'">
            <ButtonBlue
                class="button-confirm"
                :disabled="confirmButtonDisabled"
                name="confirm"
                :onClick="confirm"
                :text="$t('button.confirm')"
            />
        </div>
        <div v-else class="button-container" :class="smallMarginRight && 'smallMarginRight'">
            <ButtonBlue
                class="button-confirm yes-no-button"
                v-if="no"
                :disabled="confirmButtonDisabled"
                name="no"
                :onClick="no"
                :text="noText || $t('no')"
            />
            <ButtonBlue
                class="button-confirm yes-no-button"
                v-if="yes"
                :disabled="confirmButtonDisabled"
                name="yes"
                :onClick="yes"
                :text="yesText || $t('yes')"
            />
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import BorderedIconButton from '../ui-components/BorderedIconButton.vue';
import ButtonBlue from '../ui-components/ButtonBlue.vue';
import ButtonWhite from '../ui-components/ButtonWhite.vue';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    components: {
        BorderedIconButton,
        ButtonWhite,
        ButtonBlue,
        ReglePastille,
    },
    name: 'BottomNavigation',
    props: {
        confirmButtonDisabled: {
            type: Boolean,
            required: true,
        },
        next: {
            type: Function,
            required: false,
        },
        first: {
            type: Boolean,
            required: true,
        },
        last: {
            type: Boolean,
            required: true,
        },
        confirm: {
            type: Function,
            required: false,
        },
        cancel: {
            type: Function,
            required: false,
        },
        yes: {
            type: Function,
            required: false,
        },
        no: {
            type: Function,
            required: false,
        },
        yesText: {
            type: String,
            required: false,
        },
        noText: {
            type: String,
            required: false,
        },
        cancelText: {
            type: String,
            required: false,
        },
        back: {
            type: Function,
            required: false,
        },
        smallMarginRight: {
            type: Boolean,
            required: false,
        },
        noValidation: {
            type: Boolean,
            required: false,
        },
        isEditing: {
            type: Boolean,
            required: false,
        },
        regleCle: {
            type: String,
            required: false,
        },
    },
    computed: {
        imgUrl() {
            return require('@/assets/img/chevron-left.svg');
        },
    },
});
</script>

<style scoped>
.bandeau-container {
    box-sizing: border-box;
    background-color: var(--background-principal);
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
}
.button-container {
    margin-left: auto;
    margin-right: 90px;
}

.button-container button,
.button-cancel {
    font-size: var(--font-size-small);
    font-weight: var(--font-weight-normal);
    min-width: 95px;
    width: auto;
    padding: 0 16px;
    height: 38px;
    border-radius: 6px;
    border-width: 1px;
    border-style: solid;
    cursor: pointer;
    white-space: nowrap;
}
.button-confirm {
    margin-left: 16px;
}
.button-cancel {
    margin-left: 90px;
}
.smallMarginLeft {
    margin-left: 16px;
}
.back-button {
    margin-left: 50px;
    height: 38px;

}
.smallMarginRight {
    margin-right: 16px;
}

.yes-no-button {
    min-width: 62px;
    width: auto;
    padding: 0 12px;
}
</style>
